import { produce } from 'immer';

const initState = {
  overview_assets: {},
  overview_attack_insights: {},
  errorcode: null,
};

const EASMReducer = produce((state = initState, action) => {
  switch (action.type) {
    case 'GetOverviewAssets_SUCCESS':
      state.overview_assets = action.payload;
      return state;
    case 'GetOverviewAttackInsights_SUCCESS':
      state.overview_attack_insights = action.payload;
      return state;
    default:
      return state;
  }
});

export default EASMReducer;
